import locationModuleGetters from "./location/getters";

export default {
  ...locationModuleGetters,
};
